import { InstanceConfigs } from "../services/InstanceConfigs";

export var dateTimeTools = {

    created() {
        this.instanceConfigs = new InstanceConfigs();
        this.timezone = this.instanceConfigs.getConfig("VM_TIMEZONE");
        console.log("TIMEZONE:", "(" + this.timezone + ")");
        console.log("TIMEZONE DATE NOW:", this.dateNow());
        console.log("TIMEZONE DATETIME NOW:", this.dateTimeNow());
    },

    filters: {

        toBr(v) {
            return "666" + v;
        }

    },

    methods: {
        formateDateTime(d) {
            let date = (d.getYear() + 1900);
            date += "-" + (1 + d.getMonth()).toString().padStart(2, "0");
            date += "-" + d.getDate().toString().padStart(2, "0");
            return date + this.getHourFormatted(d);
        },

        getHourFormatted(d) {
            let hour = " " + d.getHours().toString().padStart(2, "0");
            hour += ":" + d.getMinutes().toString().padStart(2, "0");
            hour += ":" + d.getSeconds().toString().padStart(2, "0");
            return hour;
        },

        validateDatetime(dt, onlyWithHour = false) {
            return !(!dt || ((!onlyWithHour && dt.length !== 10) && dt.length !== 19));
        },

        createDate(dt) {
            if (!this.validateDatetime(dt)) {
                console.log(2, "Data inválida: " + dt + " len:" + dt.length);
                return false;
            }
            if (dt.length === 10) {
                dt += " 00:00:00";
            }
            return new Date(dt);
        },

        usToBr(dt, showHour = true) {

            const d = this.createDate(dt);

            if (!d) {
                console.log("Data inválida: " + d.toLocaleString());
                return dt;
            }

            let dateBr = d.getDate().toString().padStart(2, "0")
                + "-" + (d.getMonth() + 1).toString().padStart(2, "0")
                + "-" + (d.getYear() + 1900);

            if (showHour) {
                dateBr += this.getHourFormatted(d);
            }

            return dateBr;

        },

        brToUs(dt, showHour = true) {

            const d = this.createDate(dt);

            if (!d) {
                return dt;
            }

            let dateBr = (d.getYear() + 1900)
                + "-" + (d.getMonth() + 1).toString().padStart(2, "0")
                + "-" + d.getDate().toString().padStart(2, "0");

            if (showHour) {
                dateBr += this.getHourFormatted(d);
            }

            return dateBr;

        },

        dateNow() {
            const date = this.dateTimeNow().substr(0, 10);
            return date;
        },

        getDateObjWithTimezone() {

            if (!this.timezone) {
                this.timezone = "America/Sao_Paulo";
                console.error("Timezone inválido, aplicando o padrão: " + this.timezone);
            }

            const options = {
                year: 'numeric', month: 'numeric', day: 'numeric',
                hour: 'numeric', minute: 'numeric', second: 'numeric',
                hour12: false,
                timeZone: this.timezone
            };

            const formatter = new Intl.DateTimeFormat("en-US", options);
            const usDate = formatter.format(new Date());
            return new Date(usDate);
        },

        dateTimeNow() {
            const dt = this.getDateObjWithTimezone();
            return this.formateDateTime(dt);
        },

        dateTimeAddHours(datetime, hours = 1) {
            if (!this.validateDatetime(datetime, true)) {
                console.error(2, "Data inválida: " + dt);
                return false;
            }
            const dt = new Date(datetime);
            dt.setHours(dt.getHours() + hours);

            return this.formateDateTime(dt);
        },

        diffInDays(dtTx1, dtTx2) {
            const dt1 = this.createDate(dtTx1);
            const dt2 = this.createDate(dtTx2);
            const dt1Ms = dt1.getTime();
            const dt2Ms = dt2.getTime();
            const diffMs = dt1Ms - dt2Ms;
            const days = diffMs / 86400000;
            return Math.abs(days.toFixed(2));
        },

        parseBeginEndData(dt, type = "begin") {

            if (dt.length !== 10 && dt.length !== 19 && dt.length !== 16) {
                console.error("Data inválida: " + dt + " LEN:" + dt.length);
            }

            if (dt.length === 10 && type === "begin") {
                return dt + " 00:00:00";
            }

            if (dt.length === 10 && type === "end") {
                return dt + " 23:59:59";
            }

            if ((dt.length === 19 || dt.length === 16) && type === "begin") {
                return dt.substr(0, 16) + ":00";
            }

            if ((dt.length === 19 || dt.length === 16) && type === "end") {
                return dt.substr(0, 16) + ":59";
            }

            return dt;
        },

        detectDateFormat(data) {
            const formatos = [
                { regex: /^\d{4}-\d{2}-\d{2}$/, formato: 'YYYY-MM-DD' },
                { regex: /^\d{2}\/\d{2}\/\d{4}$/, formato: 'DD/MM/YYYY' },
                { regex: /^\d{2}-\d{2}-\d{4}$/, formato: 'DD-MM-YYYY' },
                { regex: /^\d{2}\/\d{2}\/\d{2}$/, formato: 'DD/MM/YY' },
                { regex: /^\d{4}\/\d{2}\/\d{2}$/, formato: 'YYYY/MM/DD' },
                { regex: /^\d{2}\.\d{2}\.\d{4}$/, formato: 'DD.MM.YYYY' }
            ];

            for (const { regex, formato } of formatos) {
                if (regex.test(data)) {
                    return formato;
                }
            }

            return 'Formato desconhecido: ' + data;
        }
    }
};